enum CALENDAR_DATA_SOURCE {
    HISTORY = 'history',
    GROUPED = 'grouped'
}

export default CALENDAR_DATA_SOURCE;
